<template>
  <div>
    <com-table :columns="columns" :api="api" ref="tableRef" :defaultParams="defaultParams">
      <template #status="row">
        {{ orderStatus[row.data.status] }}
      </template>
      <template #startTime="row">
        {{ row.data.startTime | timeFormate }}
      </template>
      <template #endTime="row">
        <div v-if="row.data.endTime">{{ row.data.endTime | timeFormate }}</div>
      </template>
      <template #duration="row"> {{ row.data.duration }} </template>
      <template #powerStart="row">
        {{ row.data.planPowerStart || 0 }}w-{{ row.data.planPowerEnd || 0 }}w
        {{ row.data.price || 0 }} /小时
      </template>
      <template #combo="row">
        <div v-if="row.data.payPlan && !row.data.payPlan.autoStop">
          <div v-if="row.data.payPlan.sum">{{ row.data.payPlan.sum }}元</div>
          <div v-else>{{ row.data.payPlan.duration }}小时</div>
        </div>
        <div v-else>充满自停</div>
      </template>
      <template #type="row">
        {{ payType[row.data.type] }}
      </template>
      <template #refundTime="row">
        {{ row.data.refundTime | timeFormate }}
      </template>
      <template #operation="row">
        <div>
          <el-button type="primary" size="mini" @click="handleDetail(row.data)">详情</el-button>
          <el-button
            type="default"
            size="mini"
            v-if="row.data.status === '2'"
            @click="handleEndOrder(row.data)"
            >结束订单</el-button
          >
          <el-button
            class="mt-6px"
            type="warning"
            size="mini"
            v-if="row.data.status === '2'"
            @click="handleCloseOrder(row.data)"
            >关闭订单和设备</el-button
          >
          <el-button
            v-if="!typeOfView && defaultParams.status === 3"
            type="primary"
            size="mini"
            @click="handleChargeBack(row.data)"
            >退单</el-button
          >
        </div>
      </template>
      <template #endReason="row">
        {{ row.data.errorReason }}
      </template>
      <template #refundStatus="row">
        {{ refundStatusMap[row.data.refundStatus] || '' }}
      </template>
    </com-table>
    <com-dialog :visible.sync="dialogVisible" title="退单" width="40%">
      <div>
        <div>
          <span>订单 {{ chargeBackData.number }}</span>
          <span class="ml-15px"> 订单金额 {{chargeBackData.realPaySum }} </span>
        </div>
        <div class="flex items-center mt-15px">
          <div>退款金额：</div>
          <el-input
            style="width: 300px;"
            placeholder="请输入退款金额"
            v-model="refundSum"
          ></el-input>
        </div>
        <div class="flex items-center mt-15px">
          <div>退款原因：</div>
          <el-input
            style="width: 300px;"
            placeholder="请输入退款原因"
            v-model="refundReason"
          ></el-input>
        </div>
        <div class="mt-15px flex items-center justify-end">
          <el-button type="" @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleChargeBackConfirm">确定</el-button>
        </div>
      </div>
    </com-dialog>
    <!-- <com-checked-pwd ref="checkPwdRef" @confirm="handleChargeBackConfirm" /> -->
  </div>
</template>

<script>
import { endOrderApi, closeOrderApi, orderListApi, chargeBackOrder } from '@/api/order'
import { findChargePieOrderList } from '@/api/partners'
import { orderStatus, payTypes } from '@/json/common'
import utils from 'my-tools-library'
import comCheckedPwd from '../passWord/com-checked-pwd'

export default {
  components: { comCheckedPwd },
  props: {
    defaultParams: {
      type: Object,
      default: () => {}
    },
    typeOfView: {
      type: String,
      default: ''
    },
    userCode: {
      type: String,
      default: ''
    }
  },
  watch: {
    typeOfView: {
      handler(val) {
        if (val) {
          if (val === 'partner') {
            this.columns.find(item => item.prop === 'orderDivide').hidden = false
            this.api = findChargePieOrderList
          }
          this.columns.splice(-1, 1)
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      api: orderListApi,
      orderStatus,
      payType: payTypes,

      errReasonType: {
        1: '计时结束',
        2: '输出时间到',
        3: '充电完成',
        4: '插头拔出',
        5: '功率过大',
        6: '端口异常',
        7: '高温报警',
        12: '时长超限',
        13: '温度过高',
        14: '电表故障',
        15: '电压过高',
        16: '触发漏报',
        17: '设备故障',
        18: '灭火器触发',
        19: '烟感报警',
        82: '急停结束'
      },

      refundStatusMap: {
        0: '退款中',
        1: '退款成功',
        2: '退款失败'
      },

      columns: [
        {
          label: '订单编号',
          prop: 'number',
          minWidth: '180'
        },
        {
          label: '网点名称',
          prop: 'refStoreName',
          minWidth: '150'
        },
        {
          label: '设备二维码',
          prop: 'refDevLabel',
          minWidth: '150'
        },
        {
          label: '设备编号',
          prop: 'refDevSn',
          minWidth: '160'
        },
        {
          label: '开始时间',
          prop: 'startTime',
          type: 'slot',
          slotName: 'startTime',
          width: 180
        },
        {
          label: '结束时间',
          prop: 'endTime',
          type: 'slot',
          slotName: 'endTime',
          width: 180
        },
        {
          label: '订单时长',
          prop: 'duration',
          type: 'slot',
          slotName: 'duration',
          auto: true
        },
        {
          label: '套餐',
          prop: 'combo',
          type: 'slot',
          slotName: 'combo',
          auto: true
        },
        {
          label: '电费',
          prop: 'electricCharge'
        },
        {
          label: '服务费',
          prop: 'sum'
        },
        {
          label: '电量',
          prop: 'powerConsumption'
        },
        {
          label: '订单金额',
          prop: 'paySum',
          minWidth: '150'
        },
        {
          label: '实付金额',
          prop: 'realPaySum',
          minWidth: '150'
        },
        {
          label: '订单分成',
          prop: 'orderDivide',
          minWidth: '150',
          hidden: true
        },
        {
          label: '电费成本',
          prop: 'cost',
          minWidth: '100'
        },
        {
          label: '支付方式',
          prop: 'type',
          minWidth: '90',
          type: 'slot',
          slotName: 'type'
        },
        {
          label: '用户Id',
          prop: 'refUserNumber',
          width: '150'
        },
        {
          label: '手机号码',
          prop: 'refUserPhone',
          minWidth: '150'
        },
        {
          label: '订单状态',
          prop: 'status',
          type: 'slot',
          slotName: 'status',
          minWidth: '120'
        },
        {
          label: '结束原因',
          prop: 'errorReasonCode',
          type: 'slot',
          slotName: 'endReason',
          minWidth: '120'
        },
        {
          label: '退单状态',
          prop: 'refundStatus',
          type: 'slot',
          slotName: 'refundStatus',
          minWidth: '120',
          hidden: true
        },
        {
          label: '退单金额',
          prop: 'refundSum',
          minWidth: '120',
          hidden: true
        },
        {
          label: '退单时间',
          prop: 'refundTime',
          type: 'slot',
          slotName: 'refundTime',
          auto: true,
          hidden: true
        },
        {
          label: '操作',
          prop: 'operation',
          fixed: 'right',
          type: 'slot',
          slotName: 'operation',
          width: '200'
        }
      ],
      dialogVisible: false,
      chargeBackData: {},
      refundSum: '',
      refundReason: ''
    }
  },
  methods: {
    init() {
      if (this.defaultParams.status === 6) {
        this.columns.find(item => item.prop === 'refundSum').hidden = false
        this.columns.find(item => item.prop === 'refundTime').hidden = false
        this.columns.find(item => item.prop === 'refundStatus').hidden = false
      } else {
        this.columns.find(item => item.prop === 'refundSum').hidden = true
        this.columns.find(item => item.prop === 'refundTime').hidden = true
        this.columns.find(item => item.prop === 'refundStatus').hidden = true
      }
      this.$refs.tableRef.init()
    },
    search(val) {
      this.$refs.tableRef.search(val)
    },
    handleEndOrder(row) {
      this.$confirm('此操作将结束该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const param = {
            number: row.number
          }
          endOrderApi(param).then(() => {
            this.$message.success('操作成功')
            this.$refs.tableRef.getList()
          })
        })
        .catch(() => {})
    },
    handleCloseOrder(row) {
      this.$confirm('此操作将关闭该订单与设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const param = {
            number: row.number
          }
          closeOrderApi(param).then(() => {
            this.$message.success('操作成功')
            this.$refs.tableRef.getList()
          })
        })
        .catch(() => {})
    },
    handleDetail(val) {
      const params = {
        ...val
      }
      this.$router.push({ name: 'order-detail', params })
      console.log('detail :>> ', val)
    },
    handleChargeBack(row) {
      this.refundSum = ''
      this.refundReason = ''
      this.chargeBackData = utils.deepCopy(row)
      this.dialogVisible = true
      console.log('退单 :>> ', this.chargeBackData)
    },
    // 校验密码
    handleConfirm() {
      this.$refs.checkPwdRef.open()
    },
    // 退单
    async handleChargeBackConfirm() {
      const params = {
        code: this.chargeBackData.code,
        refundPrice: this.refundSum,
        reason: this.refundReason
      }
      const res = await chargeBackOrder(params)
      if (res.status === 200) {
        this.$message.success('操作成功')
        this.dialogVisible = false
        this.init()
      }
      console.log('res :>> ', res)
    },
    async export() {
      const query = {
        pageIndex: 1,
        pageSize: 10000
      }
      const res = await orderListApi(query)
      console.log('res :>> ', res)
      console.log('daochu  :>> ')
    }
  }
}
</script>
